var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-destinationMenu",class:{
  'is-open': _vm.isOpen
}},[_c('ul',{staticClass:"p-destinationMenu__list"},_vm._l((_vm.destinations),function(destination){return _c('li',{staticClass:"u-fade"},[_c('router-link',{attrs:{"to":("/destination/" + (destination.post_name))}},[_c('figure',{staticClass:"p-destinationMenu__item"},[_c('img',{attrs:{"src":destination.acf.main_image.url,"alt":""}}),_vm._v(" "),_c('figcaption',[_vm._v(_vm._s(destination.acf.dest_name))])])])],1)}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-233ac17b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/partial/destination-menu.vue
// module id = null
// module chunks = 